const AccountSubscription = () => ({});

export default AccountSubscription;
